import { authGet } from "api/axios.config";

export const getAuthTicket = async () => {
    const { data } = await authGet("api/ticket");
    return {
        ticket: data?.ticket ?? null,
        expiresIn: data?.expires_in ?? 0,
    };
};